<template>
  <transition name="slide-left">
    <aside v-if="open" class="fixed left-0 top-16 bottom-16 z-50 w-[324px] bg-white flex flex-col mt-2">
      <!-- CLOSE BUTTON -->
      <div class="flex justify-end px-4 py-3">
        <button
          class="p-1 border border-gray-200 h-[34px] w-[34px] rounded-full hover:bg-gray-100 justify-center items-center flex"
          @click="emit('close')"
        >
          <X class="h-[20px] w-[20px] text-gray-600" />
        </button>
      </div>

      <!-- CONTENT -->
      <div class="flex-1 overflow-y-auto px-4 py-4 space-y-6 text-sm">
        <div>
          <p class="mb-3 font-bold text-[16px] text-gray-900">Profile</p>
          <div class="pl-4">
            <SidebarItem
              v-for="item in profileItems"
              :key="item.label"
              :icon="item.icon"
              :label="item.label"
              :isColor="item.label === 'Personal Details'"
              @click="navigateTo(item.to)"
            />
          </div>
        </div>

        <div>
          <p class="mb-3 font-bold text-[16px] text-gray-900">Support</p>
          <div class="pl-4">
            <SidebarItem
              v-for="item in supportItems"
              :key="item.label"
              :icon="item.icon"
              :label="item.label"
              :isColor="item.isColor"
              @click="navigateTo(item.to, item.isExternalUrl)"
            />
          </div>
        </div>

        <button class="flex items-center gap-3 text-sm" @click="emit('sign-out')">
          <LogOut class="h-4 w-4 text-brand-600" />
          Logout
        </button>
      </div>
    </aside>
  </transition>
</template>

<script setup lang="ts">
import SidebarItem from '@/components/shopper/SidebarItem.vue';
import { HELP_CENTER_URL } from '@/config';
import { LogOut, X } from 'lucide-vue-next';
import { useRouter } from 'vue-router';

defineProps<{ open: boolean }>();
const emit = defineEmits(['close', 'sign-out']);
const router = useRouter();
const profileItems = [
  { label: 'Payment Details', icon: 'Wallet' as const, isColor: true, to: '/shopper/payments' },
  { label: 'Personal Details', icon: 'User' as const, isColor: true, to: '/shopper/profile' },
];

const supportItems = [
  { label: 'Help Center', icon: 'HelpCircle' as const, isColor: true, to: HELP_CENTER_URL, isExternalUrl: true },
  { label: 'Contact Us', icon: 'PhoneColor' as const, isColor: true, to: '/shopper/contact-us', isExternalUrl: false },
];

const navigateTo = (path: string, isExternal?: boolean) => {
  if (isExternal) {
    window.open(path, '_blank');
  } else {
    router.push(path);
  }
  emit('close');
};
</script>
